import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isNavbarCollapsed = true;
  mobile = false;
  url: string = '';

  constructor(public router: Router,
  public breakpointObserver: BreakpointObserver
  ) {

  }

  ngOnInit(): void {
    this.url = this.router.url;
    this.breakpointObserver
    .observe(['(max-width: 991px)'])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.mobile = false;
      }
    });
    
    this.breakpointObserver
    .observe(['(min-width: 991px)'])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.mobile = true;
      }
    });
  }


  Includes(link: string){
    return this.router.url.includes('/news');
  }


}
